import { defineBlock, smartProps, useInspectorControl } from '@smartfire/js-block-engine'
import { ReactComponent as Facebook } from '../assets/socials/Facebook.svg'
import { ReactComponent as LinkedIn } from '../assets/socials/LinkedIn.svg'
import { ReactComponent as X } from '../assets/socials/X.svg'
import { ReactComponent as Youtube } from '../assets/socials/Youtube.svg'
import { ReactComponent as Instagram } from '../assets/socials/Instagram.svg'
import { ReactComponent as Mail } from '../assets/mail-white.svg'
import { ReactComponent as Press } from '../assets/press.svg'
import { ReactComponent as Research } from '../assets/research.svg'
import { EditableText } from '@smartfire/components'
import React from 'react'
import style from './block.module.scss'
import logoFR from '../assets/logo-white-fr.svg'
import logoEN from '../assets/logo-white-en.svg'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import i18next from 'i18next'

const Inspector = React.lazy(() => import('./Inspector'))
const getLanguage = () => i18next.language || window.localStorage.i18nextLng

function Social({ facebookUrl, linkedInUrl, twitterUrl, youtubeUrl, instagramUrl }) {
    return (
        <div className={style.socials}>
            {facebookUrl && (
                <a target="_blank" rel="noopener noreferrer" href={facebookUrl}>
                    <Facebook />
                </a>
            )}
            {twitterUrl && (
                <a target="_blank" rel="noopener noreferrer" href={twitterUrl}>
                    <X />
                </a>
            )}
            {linkedInUrl && (
                <a target="_blank" rel="noopener noreferrer" href={linkedInUrl}>
                    <LinkedIn />
                </a>
            )}
            {youtubeUrl && (
                <a target="_blank" rel="noopener noreferrer" href={youtubeUrl}>
                    <Youtube />
                </a>
            )}
            {instagramUrl && (
                <a target="_blank" rel="noopener noreferrer" href={instagramUrl}>
                    <Instagram />
                </a>
            )}
        </div>
    )
}

function Footer({
    facebookUrl,
    linkedInUrl,
    twitterUrl,
    youtubeUrl,
    instagramUrl,
    espacePress,
    mentionLegale,
    newsletter,
    researchLink,
}) {
    const { t } = useTranslation()
    useInspectorControl(Inspector)
    const logo = getLanguage() === 'fr' ? logoFR : logoEN

    return (
        <div className={style.block}>
            <div className={style.content}>
                <div className={style.leftContainer}>
                    <img src={logo} alt={'IHU-liryc'} />
                    <Social
                        facebookUrl={facebookUrl}
                        linkedInUrl={linkedInUrl}
                        twitterUrl={twitterUrl}
                        youtubeUrl={youtubeUrl}
                        instagramUrl={instagramUrl}
                    />
                </div>
                <EditableText smartProp={'informations'} className={style.midContainer} />
                <div className={style.rightContainer}>
                    <div className={style.bold}>{t('RESTONS EN CONTACT')}</div>
                    <div className={style.info}>
                        {`${t(
                            'Restez informé des actualités, avancées et évènements de l’institut',
                        )}.`}
                    </div>
                    <div className={style.newsletter}>
                        {/*todo newsletter*/}
                        <a className={clsx(style.button)} href={newsletter}>
                            <Mail className={style.image} />
                            <div>{t('S’INSCRIRE À LA NEWSLETTER')}</div>
                        </a>
                        {/*todo newsletter*/}
                    </div>
                    <a href={espacePress} className={style.press}>
                        <Press />
                        <span className={style.underline}>{t('Espace presse')}</span>
                    </a>
                    <a href={researchLink} className={style.press}>
                        <Research />
                        <span className={style.underline}>{t('Charte qualité')}</span>
                    </a>
                </div>
            </div>
            <div className={style.spacer} />
            <div className={style.subFooter}>
                © 2022 - IHU Liryc - {t('Tous droits réservés')} -{' '}
                <a href={mentionLegale}>{t('Mentions légales')}</a>
            </div>
        </div>
    )
}

export default defineBlock({
    Block: Footer,
    smartProps: {
        espacePress: smartProps.string.withDefault('/'),
        researchLink: smartProps.string.withDefault('/'),
        mentionLegale: smartProps.string.withDefault('/'),
        informations: smartProps.string.withDefault(''),
        newsletter: smartProps.string.withDefault(''),
    },
    setup: {
        title: 'Footer',
    },
})
